/*
game configuration
canvas size, colors and cue sizes, how fast the spawn should be
*/
var gameConfig = {
  width: 720,
  height: 680,
  colors: {
    sharp: 0xff0659,
    hold: 0x00c2b5,
    motion: 0xffd000,
    grid: 0xc0c0c0
  },
  cue: {
    size: 70,
    lineWidth: 11
  },
  advanceSpawn: 16
}
export default gameConfig
